import React from 'react'
import PropTypes from 'prop-types'
import GoogleLogin from 'react-google-login'

class GoogleSignupButton extends React.Component {

  static propTypes = {
    onSuccess:    PropTypes.func.isRequired,
    className:    PropTypes.string,
    clientId:     PropTypes.string.isRequired,
  }

  static defaultProps = {
    className: 'btn signup-btn-google',
    onFailure: console.warn
  }

  render() {
    const googleProps = {
      ...this.props,
      children: null,
      fetchBasicProfile: true,
    }

    return (
      <GoogleLogin {...googleProps}>
        <span className="logo"></span>
        <span className="text">{ this.props.children }</span>
      </GoogleLogin>
    )
  }
}

export { GoogleSignupButton }
